const routes = [
  {
    path: '/settings/email-suppressions',
    name: 'email-suppressions',
    meta: {
      authRequired: true,
      roles: []
    },
    component: () => import('./Index.vue')
  }
]

export { routes }
export default routes
